import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const HowItWorks = lazy(() => import('../pages/how-it-works/page'));
const Pillars = lazy(() => import('../pages/pillars/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Store = lazy(() => import('../pages/store/page'));
const About = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/pillars',
    element: <Pillars />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/store',
    element: <Store />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;